/* eslint no-shadow: */
export enum TYPE_PROMOTION {
  NPS = "NPS",
  PESQUISA_USABILIDADE = "PESQUISA_USABILIDADE",
  INCENTIVO_BOLETO_DIGITAL = "INCENTIVO_BOLETO_DIGITAL",
  NOVA_FORMA_ACESSO_BOLETO = "NOVA_FORMA_ACESSO_BOLETO",
  AVISO_MFA = "AVISO_MFA",
}
